import React from 'react';
import ReactDOM from 'react-dom/client';
import 'bootstrap/dist/css/bootstrap.min.css';
import App from './App';
import { computePortraitScale, setRootPortraitScale } from './utils/portraitScale';

setRootPortraitScale(
  computePortraitScale(window.innerWidth, window.innerHeight)
);

/** html5-qrcode leaves orphaned video.play() promises when the scan screen unmounts. */
function isOrphanedMediaPlayError(reason) {
  if (!reason) return false;
  const name = String(reason.name || '');
  const message = String(reason.message || reason || '');
  const looksLikePlayAbort =
    message.includes('play()') ||
    message.includes('media was removed') ||
    message.includes('The play() request was interrupted');
  return looksLikePlayAbort && (name === 'AbortError' || name === 'NotAllowedError' || !name);
}

window.addEventListener(
  'unhandledrejection',
  (event) => {
    if (!isOrphanedMediaPlayError(event.reason)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
  },
  true
);

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

if ('serviceWorker' in navigator) {
  const publicUrl = process.env.PUBLIC_URL || '';
  navigator.serviceWorker
    .register(`${publicUrl}/service-worker.js`)
    .then((registration) => {
      registration.update().catch(() => {});
    })
    .catch(() => {
      /* Install stays optional if the service worker cannot register. */
    });
}
